import { render, staticRenderFns } from "./group_sending.vue?vue&type=template&id=1471d6c7&scoped=true&"
import script from "./group_sending.vue?vue&type=script&lang=js&"
export * from "./group_sending.vue?vue&type=script&lang=js&"
import style0 from "./group_sending.vue?vue&type=style&index=0&id=1471d6c7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1471d6c7",
  null
  
)

export default component.exports